export default "__VITE_ASSET__C500IjGE__"